import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-tracking-popup',
  templateUrl: './tracking-popup.component.html',
  styleUrls: ['./tracking-popup.component.css']
})
export class TrackingPopupComponent implements OnInit {

  public url: String = '';
  public trackingNumber: String = '';

  constructor(public dialogRef: MatDialogRef<TrackingPopupComponent>) {
  }

  ngOnInit() {
  }

  save() {
    this.dialogRef.close({
      url: this.url,
      number: this.trackingNumber
    });
  }
}
